import {OpenUrlTarget} from '@eCommerce/frontend-legacy-shared-library-native';
import Provider from 'Provider';
import envData from 'env.json';
import React, {useEffect} from 'react';
import {createRoot} from 'react-dom/client';

import EmpireFooter from 'components/EmpireFooter';
import LegacyHeader from 'components/LegacyHeader';
import ConnectedMyRewardsFooter from 'containers/ConnectedMyRewardsFooter';
import {getLinkData, navigateOrOpenUrl} from 'utils/navigation';
import AcceptTermsScreen from 'screens/AcceptTerms';

const {API_URL} = envData;

const handleFooterItemPress = (
  title?: string,
  path?: string,
  openNewTab?: boolean
) => {
  const linkData = getLinkData(title || '', path || '');
  const {newRewardsScreen, url} = linkData;
  const prefix = url.startsWith('/') ? API_URL : '';
  const legacyUrl = `${prefix}${url}`;
  const target = openNewTab ? OpenUrlTarget.BLANK : OpenUrlTarget.SELF;

  navigateOrOpenUrl({
    legacyUrl,
    newRewardsScreen,
    target,
  });
};

const getFooterItemHref = (title?: string, path?: string) => {
  const {analyticsHref} = getLinkData(title || '', path || '');
  return analyticsHref;
};

function LegacyMyRewardsApp() {
  useEffect(() => {
    const headerContainer = document.getElementById('myrewardsHeaderComponent');
    const footerContainer = document.getElementById('myrewardsFooterComponent');
    const acceptTermsContainer = document.getElementById(
      'acceptTermsComponent'
    );
    const enterpriseFooterContainer = document.getElementById(
      'enterpriseFooterComponent'
    );

    if (headerContainer) {
      const headerRoot = createRoot(headerContainer);
      headerRoot.render(
        <>
          <Provider>
            <LegacyHeader expanded={true} />
          </Provider>
        </>
      );
    }

    if (footerContainer) {
      const footerRoot = createRoot(footerContainer);

      footerRoot.render(
        <>
          <Provider disableStartupItems={true}>
            <ConnectedMyRewardsFooter
              onFooterItemPress={handleFooterItemPress}
              footerItemHref={getFooterItemHref}
            />
          </Provider>
        </>
      );
    }

    if (enterpriseFooterContainer) {
      const enterpriseRoot = createRoot(enterpriseFooterContainer);
      enterpriseRoot.render(
        <>
          <Provider disableStartupItems={true}>
            <EmpireFooter />
          </Provider>
        </>
      );
    }

    if (acceptTermsContainer) {
      const acceptTermsRoot = createRoot(acceptTermsContainer);
      acceptTermsRoot.render(
        <>
          <Provider disableStartupItems={true}>
            <AcceptTermsScreen />
          </Provider>
        </>
      );
    }
  }, []);
  return <></>;
}

export default LegacyMyRewardsApp;
